export default {
  nav: {
    home: 'Hjem',
    spreadsheet: 'Spreadsheet',
    guides: 'Guides',
    shopping_guide: 'Købsguide',
    shipping: 'Forsendelse',
    qc: 'QC',
    reviews: 'Anmeldelser',
    categories: 'Kategorier',
    language: 'Sprog',
  },
  hero: {
    title: 'AllChinaBuy Spreadsheet – Produkter, Sælgere, QC & Købsguides',
    subtitle: 'Dit AllChinaBuy Spreadsheet & Købsresource Hub',
    description: 'Opdag nyttige AllChinaBuy spreadsheet-ressourcer, produktlister, sælgerinformation, QC-guides, forsendelsestips og praktiske købsråd — organiseret i ét nemt hub.',
    cta_primary: 'Udforsk AllChinaBuy Spreadsheet',
    cta_secondary: 'Gennemse Købsguides',
    trust: 'Uafhængige ressourcer • Opdateret indhold • Praktiske købsinformationer',
  },
  categories: {
    title: 'Populære AllChinaBuy Spreadsheet Kategorier',
    subtitle: 'Gennemse produktkategorier og find det, du har brug for, hurtigere',
    shoes: 'Sko',
    hoodies: 'Hoodies/Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jakker',
    pants: 'Bukser/Shorts',
    headwear: 'Hovedbeklædning',
    sets: 'Sæt',
    underwear: 'Undertøj',
    jersey: 'Trøjer',
    accessories: 'Tilbehør',
    bags: 'Tasker',
    belts: 'Bælter',
    perfumes: 'Parfumer',
    other: 'Andet',
  },
  cta: {
    title: 'Klar til at Begynde at Handle?',
    description: 'Besøg vores hovedwebsted for den fulde AllChinaBuy spreadsheet-oplevelse og begynd at finde produkter i dag.',
    button_main: 'AllChinaBuy Spreadsheet',
    button_buy: 'Køb Nu',
  },
  articles: {
    title: 'Seneste AllChinaBuy Spreadsheet Guides',
    subtitle: 'Lær at handle klogere med vores omfattende ressourcer',
    read_more: 'Læs Mere',
    article_1_title: 'Komplet AllChinaBuy Spreadsheet Guide 2026',
    article_1_desc: 'Alt hvad du behøver at vide om brugen af AllChinaBuy spreadsheet til at finde produkter, sammenligne sælgere og træffe informerede købsbeslutninger.',
    article_2_title: 'Sådan Læser Du AllChinaBuy QC Fotos',
    article_2_desc: 'En trin-for-trin guide til at forstå kvalitetskontrolfotos og tjekke produktdetaljer, før du køber.',
    article_3_title: 'AllChinaBuy Forsendelsesmetoder Sammenlignet',
    article_3_desc: 'Sammenlign forsendelsesmuligheder, omkostninger, leveringstider og sporingsfunktioner for at vælge den bedste metode.',
    article_4_title: 'Er AllChinaBuy Sikker? En Komplet Sikkerhedsguide',
    article_4_desc: 'Lær om sikkerhedsforanstaltninger, betalingsbeskyttelse, sælgerverifikation og hvordan du undgår almindelige svindel.',
    article_5_title: 'AllChinaBuy Anmeldelse 2026',
    article_5_desc: 'En dybdegående gennemgang af AllChinaBuy bestillingsoplevelse, lagerservice, kvalitetskontrol og forsendelse.',
    article_6_title: 'AllChinaBuy Forsendelsesomkostninger Guide',
    article_6_desc: 'Forstå forsendelsespriser, metoder, skjulte omkostninger og praktiske strategier til at reducere dine udgifter.',
    article_7_title: 'AllChinaBuy Lager Guide',
    article_7_desc: 'Sådan fungerer AllChinaBuy lageret, gratis opbevaringsperioder, QC-fotos og konsolidering forklaret.',
    article_8_title: 'AllChinaBuy Kupon & Rabat Guide',
    article_8_desc: 'Lær hvordan AllChinaBuy kampagner fungerer, hvor legitime rabatter kommer fra, og hvordan du undgår falske kuponer.',
    article_9_title: 'Er AllChinaBuy Legitimt?',
    article_9_desc: 'Hvad gør AllChinaBuy til en legitim platform, hvor de reelle risici ligger, og hvordan du beskytter dig selv.',
    article_10_title: 'AllChinaBuy Sælger Guide',
    article_10_desc: 'Sådan evaluerer du sælgere, spotter advarselstegn og opbygger en pålidelig liste.',
    article_11_title: 'Sådan Finder du Produkter på AllChinaBuy',
    article_11_desc: 'Effektive søgestrategier, filtre og verifikationstips til at finde kvalitetsprodukter hurtigere.',
    article_12_title: 'AllChinaBuy Købsguide',
    article_12_desc: 'En komplet gennemgang af AllChinaBuy købsprocessen fra din første ordre til endelig levering.',
    article_13_title: 'AllChinaBuy Forsendelsesberegner Guide',
    article_13_desc: 'Sådan estimerer du forsendelsesomkostninger præcist og bruger resultaterne til bedre beslutninger.',
    article_14_title: 'Almindelige AllChinaBuy Fejl',
    article_14_desc: 'Undgå de hyppigste fejl nye købere laver, og shop med selvtillid fra dag ét.',
  },
  features: {
    title: 'Hvorfor Bruge Vores AllChinaBuy Spreadsheet Ressourcer?',
    feature_1_title: 'Organiserede Produktlister',
    feature_1_desc: 'Find produkter på tværs af kategorier med strukturerede spreadsheets, der sparer dig timer med søgning.',
    feature_2_title: 'Sælgerinformation',
    feature_2_desc: 'Få adgang til detaljerede sælgerdata, bedømmelser og produktsortimenter for at træffe selvsikre købsvalg.',
    feature_3_title: 'QC & Kvalitetsguides',
    feature_3_desc: 'Forstå kvalitetskontrolprocesser og lær, hvad du skal tjekke, før du bekræfter ordrer.',
    feature_4_title: 'Forsendelsesressourcer',
    feature_4_desc: 'Sammenlign forsendelsesmetoder, omkostninger og leveringstider for at optimere din købsstrategi.',
  },
  footer: {
    title: 'AllChinaBuy Spreadsheet Hub',
    description: 'Din uafhængige ressource for AllChinaBuy spreadsheet-guides, produktlister og købsinformation.',
    links: 'Hurtige Links',
    resources: 'Ressourcer',
    legal: 'Juridisk',
    privacy: 'Privatlivspolitik',
    terms: 'Servicevilkår',
    disclaimer: 'Ansvarsfraskrivelse',
    contact: 'Kontakt',
    copyright: '© 2026 AllChinaBuy Spreadsheet Hub. Alle rettigheder forbeholdes.',
    disclaimer_text: 'Dette websted er en uafhængig informationsressource. Information kan ændre sig og bør verificeres uafhængigt, før der træffes købsbeslutninger.',
  },
  not_found: {
    title: 'Side Ikke Fundet',
    description: 'Siden du leder efter findes ikke. Vend tilbage til forsiden for at udforske AllChinaBuy spreadsheet-ressourcer.',
    back_home: 'Tilbage til Forsiden',
  },
  seo: {
    meta_title: 'AllChinaBuy Spreadsheet – Produkter, Sælgere, QC & Købsguides',
    meta_description: 'Udforsk den seneste AllChinaBuy spreadsheet, produktressourcer, sælgerguides, QC-tips, forsendelsesinformation og købsguides. Find produkter hurtigere og shop klogere.',
  },
  dropdown: {
    select_category: 'Vælg en Kategori',
    go: 'Gå',
  },
  products: {
    title: 'Udvalgte produkter',
    subtitle: 'Udforsk udvalgte produkter fra vores AllChinaBuy regneark — klik på et element for at se detaljer og købe på vores hovedwebsite.',
    view_all: 'Se alle',
  },
  faq: {
    title: 'Ofte Stillede Spørgsmål',
    q1: 'Hvad er AllChinaBuy Spreadsheet?',
    a1: 'AllChinaBuy spreadsheet er en organiseret ressource, der hjælper købere med at finde produkter, sælgere og købsinformation på tværs af flere kategorier. Den sparer tid ved at samle nyttige links og produktdetaljer ét sted.',
    q2: 'Er AllChinaBuy sikkert at bruge?',
    a2: 'AllChinaBuy er en legitim platform. Som med ethvert online markedsplads bør købere dog verificere sælgere, tjekke QC-fotos og bruge sikre betalingsmetoder. Vores guides hjælper dig med at handle sikkert.',
    q3: 'Hvordan finder jeg de bedste produkter?',
    a3: 'Brug vores kategoriguides og spreadsheet-ressourcer til at sammenligne produkter på tværs af sælgere. Læs QC-guides og tjek anmeldelser, før du foretager køb.',
    q4: 'Hvilke forsendelsesmetoder er tilgængelige?',
    a4: 'AllChinaBuy tilbyder forskellige forsendelsesmuligheder. Se vores forsendelsessammenligningsguide for at finde den bedste metode baseret på din placering, budget og leveringsbehov.',
  },
};